// noinspection NpmUsedModulesInstalled,DuplicatedCode

import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Paper from '@/modules/common/components/Paper';
import Button from '@/modules/common/components/Button';
import Content from '@/modules/common/components/Content';
import Spinner from '@/modules/common/components/Spinner';
import ErrorFetch from '@/modules/common/components/ErrorFetch';
import Pagination from '@/modules/common/components/Pagination';
import ContentBody from '@/modules/common/components/ContentBody';
import ContentHeader from '@/modules/common/components/ContentHeader';
import ContentBodyTop from '@/modules/common/components/ContentBodyTop';
import DialogChangePassword from '@/modules/common/components/DialogChangePassword';
import { withFetch } from '~/hocs/fetch';
import { withRouter } from '~/hocs/router';
import { actionDockSetExpandUsers } from '@/modules/application/actions/dock';
import Table from './Table';
import DialogAdd from '../DialogAddAdmin';
import DialogEdit from './DialogEdit';
import ContextMenu from './ContextMenu';
import DialogDelete from './DialogDelete';
import '../../styles/Admins.scss';

const breadcrumbs = [
    {name: 'Пользователи', to: '/users/'},
    {name: 'Администраторы'},
];

let abortController;

const Admins = (props) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [selectedAdmin, setSelectedAdmin] = useState(null);
    const [openDialogAdd, setOpenDialogAdd] = useState(false);
    const [openDialogEdit, setOpenDialogEdit] = useState(false);
    const [openDialogChangePassword, setOpenDialogChangePassword] = useState(false);
    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    const [positionContextMenu, setPositionContextMenu] = useState({left: null, top: null});

    const { enqueueSnackbar } = useSnackbar();

    const fetch = () => {
        abortController = new AbortController();
        setLoading(true);
        props.fetch.get(`/api/admins/?${props.router.urlSearchParams.toString()}`, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    setData(data);
                }
                setLoading(false);
            })
            .catch((error) => {
                setData(null);
                if (error.name !== 'AbortError') {
                    setLoading(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const closeContextMenu = () => {
        setPositionContextMenu({left: null, top: null});
    };

    useEffect(() => {
        props.dockSetExpandUsers(true);
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        let page = parseInt(props.router.urlSearchParams.get('page'));
        if (isNaN(page)) {
            page = 1;
        }
        // noinspection JSCheckFunctionSignatures
        props.router.urlSearchParams.set('page', page);
        fetch();
    }, [props.history.location.search]);

    /******************************************************************************************************************/

    const handleContextMenu = (admin) => (event) => {
        event.preventDefault();
        setSelectedAdmin(admin);
        setPositionContextMenu({left: event.clientX, top: event.clientY});
    };

    const handleClickEdit = () => {
        closeContextMenu();
        setOpenDialogEdit(true);
    };

    const handleClickChangePassword = () => {
        closeContextMenu();
        setOpenDialogChangePassword(true);
    };

    const handleClickDelete = () => {
        closeContextMenu();
        setOpenDialogDelete(true);
    };

    const handleCloseContextMenu = () => {
        closeContextMenu();
        setSelectedAdmin(null);
    };

    /******************************************************************************************************************/

    const handleAddOk = () => {
        setOpenDialogAdd(false);
        props.router.reload();
        enqueueSnackbar('Администратор добавлен', {variant: 'success'});
    };

    const handleEditOk = () => {
        setOpenDialogEdit(false);
        setSelectedAdmin(null);
        props.router.reload();
        enqueueSnackbar('Администратор изменен', {variant: 'success'});
    };

    const handleDeleteOk = () => {
        setOpenDialogDelete(false);
        setSelectedAdmin(null);
        props.router.reload();
        enqueueSnackbar('Администратор удален', {variant: 'success'});
    };

    /******************************************************************************************************************/

    // noinspection JSUnresolvedVariable
    return (
        <Content id="admins">
            <ContentHeader breadcrumbs={breadcrumbs}/>
            <ContentBody><Paper>
                {(!loading)
                    ? <>
                        {(data && data.results)
                            ? <>
                                <ContentBodyTop left={
                                    <Button onClick={() => setOpenDialogAdd(true)}>Добавить</Button>
                                }/>
                                <DialogAdd open={openDialogAdd} setOpen={setOpenDialogAdd} onOk={handleAddOk}/>
                                {(data.results.length)
                                    ? <>
                                        <Table admins={data.results} selectedAdmin={selectedAdmin}
                                               onContextMenu={handleContextMenu}
                                        />
                                        <ContextMenu position={positionContextMenu}
                                                     onClickEdit={handleClickEdit}
                                                     onClickChangePassword={handleClickChangePassword}
                                                     onClickDelete={handleClickDelete}
                                                     onClose={handleCloseContextMenu}
                                        />
                                        <DialogEdit selectedAdmin={selectedAdmin} setSelectedAdmin={setSelectedAdmin}
                                                    open={openDialogEdit} setOpen={setOpenDialogEdit}
                                                    onOk={handleEditOk}
                                        />
                                        <DialogChangePassword username={(selectedAdmin) ? selectedAdmin.username : ''}
                                                              setSelected={setSelectedAdmin}
                                                              open={openDialogChangePassword}
                                                              setOpen={setOpenDialogChangePassword}
                                        />
                                        <DialogDelete selectedAdmin={selectedAdmin} setSelectedAdmin={setSelectedAdmin}
                                                      open={openDialogDelete} setOpen={setOpenDialogDelete}
                                                      onOk={handleDeleteOk}
                                        />
                                        <Pagination totalPages={data.total_pages} currentPage={data.current_page}/>
                                    </>
                                    : null
                                }
                            </>
                            : <ErrorFetch onClick={() => fetch()}/>
                        }
                    </>
                    : <Spinner/>
                }
            </Paper></ContentBody>
        </Content>
    );
};

let Component = Admins;
Component = withRouter(Component);
Component = withFetch(Component);

export default connect(
    null,
    (dispatch) => ({
        dockSetExpandUsers: bindActionCreators(actionDockSetExpandUsers, dispatch),
    })
)(Component);
